import React from "react";
import { Helmet } from "react-helmet";
import { Footer } from "../common/FooterV2";
import Header from "../common/HeaderV2";
import VideoSection from "../common/VideoSection";

import * as styles from "./LayoutV2.module.scss";

const LayoutV2 = ({ children, title = "Multi-Regnskab", withSearch = false, articles = [] }) => {
  if (typeof window !== "undefined") {
    // eslint-disable-next-line global-require
    require("smooth-scroll")('a[href*="#"]');
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content="Holding company" />
      </Helmet>
      {withSearch && <Header articles={articles} />}
      <main className={styles.layout}>{children}</main>
      <VideoSection />
      <Footer />
    </>
  );
};

export default LayoutV2;
